import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { GiftVoucher, PDPLayout, PDPLayoutItemArea } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, Divider, useMediaQueryMatchesOnMobile, useMediaQueryMatchesOnDesktop, TextAlpha, } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { GiftVoucherForm, } from '../components/gift-voucher/gift-voucher-form/GiftVoucherForm';
import { GiftVoucherMainSlider } from '../components/gift-voucher/GiftVoucherMainSlider';
import { GiftVoucherThumbSlider } from '../components/gift-voucher/GiftVoucherThumbSlider';
import AdvantagesBlock from '../components/product-detail/advantages-block/AdvantagesBlock';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { useCarouselWithThumbs } from '../hooks/useCarouselWithThumbs';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { makeGetBasketPopupCollapseState } from '../redux/basket/selectors/BasketSelector';
import { makeGetProductDefaults } from '../redux/product/selectors/ProductSelector';
import { getImageFromCdn } from '../util/ImageUtil';
import MonetateUtil from '../util/MonetateUtil';
import AsNumeral from '../vendors/asNumeral';
import BasketPopupContainer from './BasketPopupContainer';
const TEXTAREA_ROWS = {
    DESKTOP: 5,
    MOBILE: 10,
};
const GiftVoucherContainer = ({ title, subtitle, amountConfig, basketPopUp, advantages, images, logo, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const [textareaRows, setTextareaRow] = useState(TEXTAREA_ROWS.DESKTOP);
    const [amount, setAmount] = useState();
    const [message, setMessage] = useState();
    const [formHelpers, setFormHelpers] = useState();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const isMobile = useMediaQueryMatchesOnMobile();
    const { currency, mainWebShop, product: productConfig, imageCdnPrefix } = useAemConfig();
    const voucherSizeCode = productConfig.voucher.productSize;
    const dispatch = useDispatch();
    const isBasketPopupCollapsed = useSelector(makeGetBasketPopupCollapseState());
    const { productId } = useSelector(makeGetProductDefaults());
    const { selectedIndex: activeSlideIndex, setMainApi, setThumbApi, onThumbClick } = useCarouselWithThumbs();
    const giftVoucherTranslations = {
        example: t(`${I18N_NAMESPACES.general}:voucher.example`),
        disclaimer: (fascia) => t([
            `${I18N_NAMESPACES.general}:voucher.disclaimer.${fascia}`,
            `${I18N_NAMESPACES.general}:voucher.disclaimer.unspecific`,
        ], { fascia }),
        webcode: t(`${I18N_NAMESPACES.general}:voucher.webcode`),
        date: t(`${I18N_NAMESPACES.general}:voucher.date`),
    };
    useEffect(() => {
        setTextareaRow(isDesktop ? TEXTAREA_ROWS.DESKTOP : TEXTAREA_ROWS.MOBILE);
    }, [isDesktop, isMobile]);
    useEffect(() => {
        if (isBasketPopupCollapsed && formHelpers) {
            formHelpers.resetForm();
            setAmount('');
            setMessage('');
        }
    }, [isBasketPopupCollapsed]);
    useEffect(() => {
        dispatch(analyticsActions.giftVoucherInit(currency));
        MonetateUtil.pushProductDetailEvent(productId);
    }, []);
    if (!images) {
        return null;
    }
    const addVoucher = (values, helpers) => {
        const image = images[activeSlideIndex].imagePath;
        let templateName = image.substr(Number(image.lastIndexOf('/')) + 1);
        templateName = templateName.substring(0, templateName.indexOf('.'));
        dispatch(basketActions.createAddVoucherAction({
            voucherSizeCode,
            image,
            amount: Number(values.amount),
            quantity: 1,
            message: values.message,
            imageTemplateName: templateName,
        }));
        if (!formHelpers) {
            setFormHelpers(helpers);
        }
    };
    return (_jsx(PDPLayout, { children: _jsxs(Box, { paddingBlockStart: { base: '4', md: '6', lg: '0' }, paddingBlockEnd: { base: '8', md: '0' }, children: [_jsxs(PDPLayout.Item, { area: PDPLayoutItemArea.HEADER, children: [_jsx(Box, { paddingBlockEnd: "4", children: _jsx(TextAlpha, { as: "h1", variant: "subheadingXL", children: title }) }), _jsx(Box, { paddingBlockEnd: { base: '6', md: '2' }, children: _jsx(TextAlpha, { as: "span", variant: "bodyS", children: subtitle }) })] }), _jsxs(PDPLayout.Item, { area: PDPLayoutItemArea.PREVIEW, children: [_jsx(GiftVoucherMainSlider, { images: images, setApi: setMainApi, imageCdnPrefix: imageCdnPrefix }), _jsx(GiftVoucher, { amount: amount && AsNumeral.formatAsCurrency(Number(amount)), currency: currency, logo: logo ? getImageFromCdn(logo, imageCdnPrefix) : '', message: message, mainWebShop: mainWebShop, translations: giftVoucherTranslations })] }), _jsxs(PDPLayout.Item, { area: PDPLayoutItemArea.INTERACTION_BLOCK, children: [_jsxs(Box, { paddingBlockEnd: "8", children: [_jsx(TextAlpha, { as: "span", variant: "bodyS", strong: true, children: t(`${I18N_NAMESPACES.general}:voucher.selectImage.label`) }), _jsx(GiftVoucherThumbSlider, { activeSlideIndex: activeSlideIndex, images: images, imageCdnPrefix: imageCdnPrefix, setApi: setThumbApi, onThumbClick: onThumbClick })] }), _jsx(GiftVoucherForm, { currency: currency, minAmount: amountConfig.minAmount, maxAmount: amountConfig.maxAmount, onSubmit: addVoucher, onAmountChange: setAmount, onMessageChange: setMessage, textareaRows: textareaRows }), advantages && (_jsxs(_Fragment, { children: [_jsx(Box, { paddingBlock: { base: '4', lg: '6' }, children: _jsx(Divider, {}) }), _jsx(AdvantagesBlock, { advantages: advantages })] }))] }), _jsx(BasketPopupContainer, { recommendations: basketPopUp, enablePriceReference: false })] }) }));
};
export default GiftVoucherContainer;
